<template>
  <div>
    <h5 class="domain-label">{{ domain.producer }}</h5>
    <p v-if="isShippingFree" class="shipping-label shipping-label--success">Vous bénéficiez du franco de port pour ce domaine</p>
    <p v-else class="shipping-label shipping-label--danger">
      {{ requiredProductLabel }}
      <span class="suggestion-btn" @click="isSupplyShown = !isSupplyShown" v-if="domain.hasFreeShipping">{{ suggestionBtnLabel }}</span>
    </p>
    <CartDomainProducts v-if="!isShippingFree && isSupplyShown && domain.hasFreeShipping" :products="domain.supply.other_products" />
    <CartProduct
      v-for="(line, index) in domain.lines"
      :key="index"
      v-bind="line"
      @remove="$emit('remove', line.product_id)"
      @update="(newQuantity) => $emit('update', line.product_id, line.quantity, newQuantity)"
    />
  </div>
</template>

<script>
import priceFormat from "../utils/priceFormat";
import chargeableBtls from "../utils/chargeableBtls";
import CartProduct from "./CartProduct";
import CartDomainProducts from "./CartDomainProducts";

export default {
  props: {
    domain: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isSupplyShown: false
    };
  },
  computed: {
    freeShippingType() {
      if (this.domain.lines[0].free_shipping_amount && this.domain.lines[0].free_shipping_bottles) {
        return "both";
      }

      if (this.domain.lines[0].free_shipping_amount) {
        return "price";
      }

      if (this.domain.lines[0].free_shipping_bottles) {
        return "quantity";
      }

      return "none";
    },
    totalProductPrice() {
      return this.domain.lines.reduce((acc, line) => line.free_shipping_amount ? acc + line.price * chargeableBtls(line) : acc, 0);
    },
    totalProductCount() {
      return this.domain.lines.reduce((acc, line) => line.free_shipping_bottles ? acc + line.quantity : acc, 0);
    },
    isShippingFree() {
      switch (this.freeShippingType) {
        case "both":
          return this.totalProductPrice >= this.domain.free_shipping_amount || this.totalProductCount >= this.domain.free_shipping_bottles;

        case "quantity":
          return this.totalProductCount >= this.domain.free_shipping_bottles;

        case "price":
          return this.totalProductPrice >= this.domain.free_shipping_amount;

        default:
          return false;
      }
    },
    requiredProductLabel() {
      switch (this.freeShippingType) {
        case "both":
          return `Ajoutez ${priceFormat(this.domain.free_shipping_amount - this.totalProductPrice)}€ de commande ou ${this.domain.free_shipping_bottles - this.totalProductCount} bouteilles de ce fournisseur pour bénéficier du franco de port.`;

        case "quantity":
          return `Ajoutez ${this.domain.free_shipping_bottles - this.totalProductCount} bouteilles de ce fournisseur pour bénéficier du franco de port.`;

        case "price":
          return `Ajoutez ${priceFormat(this.domain.free_shipping_amount - this.totalProductPrice)}€ de commande de ce fournisseur pour bénéficier du franco de port.`;

        case "none":
          return "Prix départ CHAI pour ce domaine";

        default:
          return false;
      }
    },
    suggestionBtnLabel() {
      return !this.isShippingFree && this.isSupplyShown ? "Masquer les offres" : "Voir les offres";
    }
  },
  created() {
    this.isSupplyShown = !this.isShippingFree && this.freeShippingType !== "none";
  },
  components: {
    CartProduct,
    CartDomainProducts
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.domain-label {
  margin: $global-margin 0 0 0;
}

.shipping-label {
  margin: 0.25em 0;
  font-size: 0.875em;
  font-style: italic;

  &--success {
    color: $color-success;
  }

  &--danger {
    color: $color-danger;
  }
}

.suggestion-btn {
  color: $color-primary;
  font-weight: 800;
  font-style: initial;
  margin-left: 0.125em;
  text-decoration: underline;
  cursor: pointer;
}
</style>
